import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router'

import { THEME_PALETTE } from '../../../../../../constants/constants'
import ActionLink from '../../../../ActionLink'
import { useGlobalSearch } from '../../../hooks/useGlobalSearch'

type Props = React.ComponentProps<typeof Link>

const SearchResultLink: React.FC<Props> = ({ className, ...props }) => {
  const globalSearch = useGlobalSearch()

  return (
    <ActionLink
      beforeNavigate={globalSearch.hide}
      className={classNames(
        'border-box rounded-2 text-decoration-none text-reset text-sm',
        className,
      )}
      css={{
        padding: '6px 14px',
        '&:hover': {
          backgroundColor: THEME_PALETTE['gray-100'],
        },
      }}
      {...props}
    />
  )
}

export default SearchResultLink
